import {
  UPDATE_AE_REGION,
  UPDATE_AE_REGION_SELECTION,
} from './constants'
import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'

const updateAeRegion = (prevRegion, { regions }) => regions
const updateAeRegionSelection = (prevRegion, { regions }) => regions

const aeRegionReducer = createReducer([], {
  [UPDATE_AE_REGION]: updateAeRegion,
})

const aeRegionSelectionReducer = createReducer([], {
  [UPDATE_AE_REGION_SELECTION]: updateAeRegionSelection,
})

export default combineReducers({
  aeRegion: aeRegionReducer,
  aeRegionSelection: aeRegionSelectionReducer
})
